import queryKeys from '@/constants/queryKeys';
import { getProviderById } from '@/services/api/requests/providers';
import { useQuery } from '@tanstack/react-query';

const useProviderById = (id: string) => {
  const { isPending, isLoading, isSuccess, data, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.providers.byId, id],
    queryFn: async () => {
      const response = await getProviderById(id);
      return response;
    },
  });

  return { isPending, isLoading, isSuccess, data, isRefetching, refetch };
};

export default useProviderById;
